import { render, staticRenderFns } from "./SgaStepHeader.vue?vue&type=template&id=6ef74b50"
import script from "./SgaStepHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./SgaStepHeader.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports